import { render, staticRenderFns } from "./TutorSlideNotesComponent.vue?vue&type=template&id=125b9e3e&scoped=true&"
import script from "./TutorSlideNotesComponent.vue?vue&type=script&lang=js&"
export * from "./TutorSlideNotesComponent.vue?vue&type=script&lang=js&"
import style0 from "./TutorSlideNotesComponent.vue?vue&type=style&index=0&id=125b9e3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b9e3e",
  null
  
)

export default component.exports